export default __webpack_public_path__ + "logo-dark.c6e1dee9d6be861b6b21a9da35785679.svg";